
define('jsx!components/lists/section',['jquery', 'underscore', 'react', 'lib', 'classnames', 'jsx!components/react-if/main'], function($, _, React, lib, classNames, If) {
    'use strict';

    function tagsList(id) {
        var tags = {
            13256: [
                { id: 13505, name: 'Ledelse' },
                { id: 12878, name: 'Arbeidsliv' },
                { id: 13511, name: 'HR' },
                { id: 13541, name: 'Arbeidsreglement' },
                { id: 13534, name: 'Oppsigelse' },
                { id: 13528, name: 'Arbeidsmiljøloven' },
                { id: 13510, name: 'Arbeidsrett' },
                { id: 13515, name: 'Sykefravær' },
                { id: 13530, name: 'Lønn' },
                { id: 2170, name: 'Pensjon' },
                { id: 13533, name: 'Nedbemanning' },
                { id: 13525, name: 'Foreldrepermisjon' },
                { id: 11616, name: 'Jobbintervju' },
                { id: 10120, name: 'Likestilling' },
                { id: 1561, name: 'Ferie' },
                { id: 13526, name: 'CV' },
                { id: 13521, name: 'Bonus' },
            ]
        };

        return tags[id] || null;
    }

    var PureRenderMixin = React.addons.PureRenderMixin;
    var SectionList = React.createClass({displayName: "SectionList",
        mixins: [PureRenderMixin],
        getInitialState: function() {
            return {
                url: '/articles',
                list: [],
                limit: 20,
                offset: 0,
                loading: false,
                empty: false,
                expanded: false,
                keyword: this.props.keywordId,
            };
        },
        componentDidMount: function() {
            this.updateList();
        },
        updateList: function(args) {
            var query = {
                limit: (args && args.limit) ? args.limit : this.state.limit,
                offset: (args && args.offset) ? args.offset : this.state.offset,
                keyword: (args && args.keyword) ? args.keyword : this.state.keyword,
                category: this.props.sectionId,
                large: this.props.large
            };
            this.setState({
                loading: true
            });
            $.getJSON(lib.getApiUrl(this.props.url), query).done(_.bind(function(list) {
                this.setState({
                    list: React.addons.update(this.state.list, {$push: list}),
                    limit: this.state.limit,
                    offset: parseInt(this.state.offset) + this.state.limit,
                    loading: false,
                    empty: list.length > 0 ? false : true
                });
                $(this.props.element).removeClass('loading');
            }, this));
        },
        getAuthorInfo: function(article) {
            if (article.authorInfo) {
                if (this.props.large && !article.authorInfo.section) {
                    return React.createElement("div", {className: "related-author-info"}, 
                        React.createElement("img", {className: "related-author-info__image", src: article.authorInfo.image}), 
                        React.createElement("div", {className: "related-author-info__container"}, 
                            React.createElement("p", {className: "related-author-info__description"}, this.props.dnn ? 'forfatter' : 'kommentar'), 
                            React.createElement("p", {className: "related-author-info__name"}, article.authorInfo.name)
                        )
                    );
                } else {
                    return React.createElement("div", {className: 'related-author-info related-author-info--compact' + (article.authorInfo.section ? (' related-author-info--' + article.authorInfo.section) : '')}, 
                        React.createElement("p", {className: "related-author-info__description"}, article.authorInfo.section ? article.authorInfo.section : 'kommentar')
                    );
                }
            }
        },
        getTags: function() {
            var tags = tagsList(this.props.keywordId);
            var keyword = this.props.keywordId || 0;
            if (tags) {
                return React.createElement("div", {className: "section-tags"}, 
                    React.createElement("ul", null, 
                        React.createElement("li", {className: 'section-tag' + ((this.state.keyword && this.state.keyword !== keyword) ? '' : ' active'), onClick: this.setTag.bind(this, keyword), "data-stats-type": "navigation", "data-stats-string": 'ArticleList::section::sectiontaglist::'+ (this.props.header ? this.props.header + '::' : '') + 'Alle'}, "Alle"), 
                        _.map(tags, _.bind(function(tag, i) {
                            var className = classNames('section-tag', {
                                active: this.state.keyword === tag.id,
                                hidden: i > (lib.isMobile() ? 4 : 9) && !this.state.expanded
                            });
                            return React.createElement("li", {key: tag.id, className: className, onClick: this.setTag.bind(this, tag.id), "data-stats-type": "navigation", "data-stats-string": 'ArticleList::section::sectiontaglist::'+ (this.props.header ? this.props.header + '::' : '') + tag.name}, tag.name);
                        }, this)), 
                        React.createElement("li", {className: 'section-tag expand' + (this.state.expanded ? ' hidden' : ''), onClick: this.toggleTags, "data-stats-type": "navigation", "data-stats-string": 'ArticleList::section::sectiontaglist::'+ (this.props.header ? this.props.header + '::' : '') + 'Expand'}, "...")
                    )
                );
            }
        },
        setTag: function(id) {
            if (this.state.keyword === id) {
                return;
            }

            var args = {keyword: id, limit: 20, offset: '0', list: []};
            this.setState(args);
            this.updateList(args);
        },
        toggleTags: function() {
            this.setState({
                expanded: this.state.expanded ? false : true
            });
        },
        renderImage: function(article) {
            if (!article.thumbnail) {
                return null;
            }

            return React.createElement("div", {className: "image-container"}, 
                article.paywall ? (
                    React.createElement("div", {className: "e24-sprite-container"}, 
                        React.createElement("span", {className: "e24-icon-e24pluss"})
                    )
                ) : '', 
                React.createElement("img", {className: "image-container-img", src: article.thumbnail}), 
                this.getAuthorInfo(article)
            );
        },
        renderMore: function() {
            if (this.state.empty) {
                return null;
            }

            if (this.state.loading) {
                return React.createElement("div", {className: "more-wrapper"}, React.createElement("div", {className: "e24-spinner"}, React.createElement("div", {className: "double-bounce1"}), React.createElement("div", {className: "double-bounce2"})));
            } else {
                return React.createElement("div", {className: "more-wrapper"}, React.createElement("div", {onClick: this.updateList.bind(this, null), className: "more"}, "Vis flere"));
            }
        },

        renderPoster: function(articleEl) {
            return React.createElement("div", null, 
                articleEl, 
                React.createElement("div", {className: "dnn-poster"}, 
                    React.createElement("div", {className: "dnn-poster-inner"}, 
                        React.createElement("h2", null, "Det nye Norge"), 
                        React.createElement("p", null, "En kronikk- og artikkelserie på E24, hvor noen av landets ledende stemmer skal forklare hvordan Norge skal gjennomføre den nye, industrielle revolusjonen: Digitaliseringen."), 
                        React.createElement("p", null, "Gjennom selvskrevne kronikker, og også redaksjonelle saker hos E24, skal gründere, bedriftsledere og politikere med egne ord legge frem sine løsninger og mulighetsbeskrivelser."), 
                        React.createElement("a", {href: lib.getBasePath('/tips-oss/det-nye-norge'), className: "more"}, "Tips redaksjonen")
                    )
                )
            );
        },

        getClass: function(i) {
            if (!this.props.large) {
                return null;
            }

            if (this.props.dnn) {
                return i === 0 ? 'large' : 'small' + (i % 2 === 1 ? ' left' : '');
            }

            return i % 5 === 0 ? 'large' : 'small' + (i % 5 === 1 || i % 5 === 3 ? ' left' : '');
        },

        renderArticle: function(article, i) {
            var classType = this.getClass(i);
            var articleType = article.articleType && !article.authorInfo ? article.articleType + ' ' + article.articleType+'-small' : null;
            var className = classNames(articleType, classType);
            var url = article.url || lib.getBasePath('/article/' + article.id);

            var articleEl = React.createElement("li", {key: article.id + '-' + i, className: className}, 
                React.createElement("a", {href: url, "data-artid": article.id}, 
                    this.renderImage(article), 
                    article.paywall ? (
                        React.createElement("h6", {className: "e24-plus-subscription-required"}, "For abonnenter")
                    ) : '', 
                    React.createElement("h2", null, article.presentationTitle ? article.presentationTitle : article.title), 
                    React.createElement("p", null, article.preamble), 
                    !article.paywall && (React.createElement("time", {dateTime: lib.getDateTime(article.published), className: "published"}, lib.getTimeSince(article.published)))
                )
            );

            if (this.props.dnn && i === 0) {
                return this.renderPoster(articleEl);
            }

            return articleEl;
        },

        render: function() {
            return React.createElement("div", {className: "articles-list article-section-list", "data-art-list": "sectionlist"}, 
                this.getTags(), 
                React.createElement(If, {condition: this.props.header}, 
                React.createElement("header", {className: "e24-tag-header e24-tag-header--offset"}, 
                    React.createElement("h6", null, this.props.header)
                )
                ), 
                React.createElement("ul", null, 
                    _.map(this.state.list, _.bind(function(article, i) {
                        return this.renderArticle(article, i);
                    },this))
                ), 
                this.renderMore()
            );
        }
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }

        config = config || {};
        config.keywordId = element.getAttribute('data-keyword-id');
        config.sectionId = element.getAttribute('data-section-id');
        config.header = element.getAttribute('data-header');
        config.large = element.getAttribute('data-large');
        config.dnn = element.getAttribute('data-dnn');
        config.url = config.url || element.getAttribute('data-url');
        config.element = element;

        React.render(React.createElement(SectionList, React.__spread({},  config)), element);
    };
});

